import { render } from "./TemplatePreviewModal.vue?vue&type=template&id=51720852&scoped=true"
import script from "./TemplatePreviewModal.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewModal.vue?vue&type=script&lang=js"

import "./TemplatePreviewModal.vue?vue&type=style&index=0&id=51720852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51720852"]])

export default __exports__